import { Component } from '@angular/core';
import { HomeContactUsComponent } from '../home/contact-us/contact-us.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [ HomeContactUsComponent,FooterComponent],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {
  constructor(private titleService: Title, private meta: Meta,) {

    const title = 'Help Me Softnet - Negombo, Best in Sri Lanka'
    const des = "Help Me Softnet? Softnet Got You Covered! Get expert help from us for installations, configuration, and troubleshooting. We also build PCs & sell laptops. Trusted warranty & support. Call Now:077 2553478"

    try {
      this.meta.removeTag('title');
      this.meta.removeTag('description');

      this.meta.removeTag('og:type');
      this.meta.removeTag('og:url');
      this.meta.removeTag('og:title');
      this.meta.removeTag('og:description');
      this.meta.removeTag('og:image');


      this.meta.removeTag('twitter:card');
      this.meta.removeTag('twitter:url');
      this.meta.removeTag('twitter:title');
      this.meta.removeTag('twitter:description');
      this.meta.removeTag('twitter:image');
      this.meta.removeTag('twitter:image');
    } catch (error) {

    }
    this.titleService.setTitle(title)
    this.meta.addTag({ name: 'title', content: title });

    this.meta.addTag({ name: 'description', content: des });

    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:url', content: 'https://softnetcomputers.lk' + '/contact-us' });
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ name: 'og:description', content: des });
    this.meta.addTag({ property: 'twitter:url', content: 'https://softnetcomputers.lk' + '/contact-us' });
    this.meta.addTag({ property: 'twitter:title', content: title });
    this.meta.addTag({ name: 'twitter:description', content: des });

  }
}
